import { render, staticRenderFns } from "./BulkSettingsPanel.vue?vue&type=template&id=670100cb"
import script from "./BulkSettingsPanel.vue?vue&type=script&lang=js"
export * from "./BulkSettingsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports